import React from 'react';

import { Button, Card, Col, message, Popconfirm, Row, Tag } from 'antd';

import IsBoss from '../hocs/is-boss';

import EnterpriseSelectionModal from '../enterprise/selection-modal';

import { API_ENDPOINT } from '../../index';

import { 
	_postDeleteUser,
	_postLogoutFromAllDevices,
	_postChangePermission
} from '../../services';

class UserProfileOverview extends React.Component{
	
	state = {
		showEnterpriseSelectionModal: false
	}

	render(){

		const { user } = this.props;

		const { showEnterpriseSelectionModal } = this.state;

		let email, name;

		if( !user || !user.local ){
			email = 'loading..';
			name = false;
		} else {
			email = user.local.email;
			name = user.details.name;
		}

		return (
			<Card title="User Management Interface">
				
				<Row type="flex">
					<Col></Col>
					<Col>

						<Row type="flex" align="middle" gutter={8}>
							{/* Name/Title */}
							<Col>
								<strong>{email} {name? `| ${name}`: ''}</strong>
							</Col>

							{/* Action */}
							{/* <Col>

								<Button onClick={this.handleOpenEnterpriseSelectionModal}>
									Assign Enterprise
								</Button>

							</Col> */}

							<Col>
								<Button 
								onClick={this.handleToggleAdmin}>
									{user.permissions && user.permissions.ezAdmin?
									"Remove As Admin"
									:
									"Make Admin"
									}
								</Button>
							</Col>
							
							<Col>
								<IsBoss>
									<Button href={`${API_ENDPOINT}/api/admin/developer/login/${user._id}`}>
										Developer Login
									</Button>
								</IsBoss>
							</Col>
							

							
							<Col>
								<IsBoss>
									<Button onClick={ this.handleLogoutFromAllDevices }>
										Logout from all devices
									</Button>
								</IsBoss>
							</Col>

							{!user.deleted && <IsBoss>
								<Col>
									<Popconfirm title="ARE U SURE? THIS CANT BE REVERSED!!" okText="YES DELETE" onConfirm={ this.handleDeleteUser }>
										<Button type="danger">
											Delete User
										</Button>
									</Popconfirm>
								</Col>
							</IsBoss>}

							{user.deleted && <Col>
								<Tag color='red'>Deleted</Tag>
							</Col>}

						</Row> 

						<Row>
							{/* Content */}
							<Col></Col>

							{/* Extra Content */}
							<Col></Col>
						</Row>

					</Col>
				</Row>

				<EnterpriseSelectionModal 
					onCancel={ this.handleCloseEnterpriseSelectionModal }
					visible={showEnterpriseSelectionModal} 
					enterpriseId={ user.enterpriseId }
					userId={ user._id } /> 

			</Card>
		)
	}

	handleToggleAdmin = () => {
		_postChangePermission({unit: 'ezAdmin', _id: this.props.user._id })
		.then(() => {
			this.props.setUser()
		})
	}

	handleCloseEnterpriseSelectionModal = () => {
		this.setState({
			showEnterpriseSelectionModal: false
		})
	}

	handleDeleteUser = () => {

		const { user } = this.props;

		let loadingMsg = message.loading(`Deleting ${user.local.email}...`);

		_postDeleteUser( user._id )
			.then( res => {
				
				loadingMsg();
				
				message.success(`Deleted ${user.local.email}`);

				message.loading("Closing window in 3 seconds", 0);

				setTimeout(() => {
					window.close();
				}, 3000);

			});
	}

	// handleDeveloperLogin = () => {
	// 	const { user } = this.props;

	// 	_getLoginAsDeveloper({ userId: user._id })
	// 		.then( res => {
	// 			window.location.r
	// 		});

	// }

	handleLogoutFromAllDevices = () => {

		const { user } = this.props;

		const userId = user._id;

		_postLogoutFromAllDevices({ userId })
			.then( res => {
				message.success(`Logged out of ${res.data.count} devices`);
			})
			.catch( e => {
				message.error('ERROR: Please contact developers');
			})

	}

	handleOpenEnterpriseSelectionModal = () => {
		this.setState({
			showEnterpriseSelectionModal: true
		})
	}

}

export default UserProfileOverview;


// WEBPACK FOOTER //
// ./src/components/user/user-profile-overview.js